/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Style_Guide_Errors_Found_ToastInputs */



/**
* | output |
* | --- |
* | "{count} errors found" |
*
* @param {Style_Guide_Errors_Found_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_errors_found_toast = /** @type {((inputs: Style_Guide_Errors_Found_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Errors_Found_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} erreurs trouvees`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Fehler gefunden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} errori trovati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} обнаружены ошибки`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} errores encontrados`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`发现${i?.count}错误`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} エラーが見つかりました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} त्रुटियाँ पाई गईं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erros ${i?.count} encontrados`)
	return /** @type {LocalizedString} */ (`${i?.count} errors found`)
});